import React from 'react';

export const MetaIcon = () => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1899 2.31346C13.8915 1.78574 13.4651 1.34155 12.95 1.02176C12.435 0.701974 11.8477 0.516863 11.2424 0.483459C10.5289 0.514258 9.8513 0.805033 9.33739 1.30096C8.91224 1.68608 8.53001 2.11608 8.19739 2.58346C7.83753 2.11069 7.42766 1.67818 6.97489 1.29346C6.37578 0.772397 5.60889 0.484812 4.81489 0.483459C4.18118 0.528531 3.5693 0.733868 3.03668 1.0802C2.50406 1.42653 2.06816 1.90251 1.76989 2.46346C0.938535 3.8174 0.497311 5.37466 0.494893 6.96346C0.49125 7.37735 0.536565 7.79022 0.629893 8.19346C0.704681 8.55322 0.83903 8.89796 1.02739 9.21346C1.25378 9.60289 1.58426 9.92149 1.98172 10.1335C2.37918 10.3454 2.82787 10.4424 3.27739 10.4135C4.21489 10.4135 4.91989 9.99346 5.75239 8.91346C6.37613 8.05918 6.9304 7.15629 7.40989 6.21346L7.88239 5.37346C7.92739 5.30596 7.96489 5.23846 8.00239 5.17096L8.11489 5.35846L9.45739 7.60846C9.88725 8.35847 10.4032 9.05569 10.9949 9.68596C11.2437 9.93751 11.5424 10.1342 11.8718 10.2634C12.2011 10.3925 12.5539 10.4513 12.9074 10.436C13.2762 10.4502 13.6429 10.3736 13.9751 10.2127C14.3074 10.0518 14.5949 9.81169 14.8124 9.51346C14.8632 9.44733 14.9083 9.37709 14.9474 9.30346C15.0386 9.15308 15.1164 8.99497 15.1799 8.83096L15.2699 8.56846C15.3706 8.29086 15.4459 8.00469 15.4949 7.71346C15.5088 7.46365 15.5088 7.21327 15.4949 6.96346C15.5267 5.31885 15.0728 3.70138 14.1899 2.31346ZM6.59989 4.98346C6.11989 5.73346 5.42239 6.86596 4.82239 7.69096C4.07239 8.71846 3.68989 8.82346 3.26989 8.82346C3.09479 8.82674 2.92208 8.78243 2.77018 8.69525C2.61828 8.60808 2.49289 8.48131 2.40739 8.32846C2.19731 7.93738 2.09628 7.497 2.11489 7.05346C2.09811 5.70237 2.45639 4.3731 3.14989 3.21346C3.31203 2.9089 3.54672 2.64898 3.83319 2.45669C4.11967 2.2644 4.44911 2.14566 4.79239 2.11096C5.12571 2.12652 5.45139 2.21602 5.74585 2.37298C6.0403 2.52993 6.29616 2.75042 6.49489 3.01846C6.76397 3.33095 7.0144 3.65902 7.24489 4.00096L6.59989 4.98346ZM12.9149 8.82346C12.5549 8.82346 12.2774 8.68096 11.8799 8.20096C11.2337 7.32601 10.6426 6.41175 10.1099 5.46346L9.71989 4.81846C9.44989 4.36096 9.18739 3.94846 8.96989 3.58096C9.00877 3.51125 9.05133 3.44365 9.09739 3.37846C9.80239 2.33596 10.4249 1.75096 11.1974 1.75096C11.5881 1.78536 11.9638 1.9174 12.2902 2.13494C12.6165 2.35249 12.8829 2.64857 13.0649 2.99596C13.7696 4.2109 14.1252 5.59682 14.0924 7.00096C14.0624 7.98346 13.8374 8.82346 12.9149 8.82346Z"
      fill="#333"
    />
  </svg>
);

export const TikTokIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.45 3.03633C8.93743 2.45097 8.65492 1.69938 8.655 0.921326H6.3375V10.2213C6.31999 10.7247 6.10764 11.2016 5.74523 11.5514C5.38282 11.9013 4.89869 12.0966 4.39499 12.0963C3.33 12.0963 2.445 11.2263 2.445 10.1463C2.445 8.85633 3.69 7.88883 4.9725 8.28633V5.91633C2.385 5.57133 0.119995 7.58133 0.119995 10.1463C0.119995 12.6438 2.19 14.4213 4.3875 14.4213C6.7425 14.4213 8.655 12.5088 8.655 10.1463V5.42883C9.59474 6.10371 10.723 6.46581 11.88 6.46383V4.14633C11.88 4.14633 10.47 4.21383 9.45 3.03633Z"
      fill="#333"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25234 3.70678C5.40783 3.70678 3.92004 5.19457 3.92004 7.03908C3.92004 8.88358 5.40783 10.3714 7.25234 10.3714C9.09684 10.3714 10.5846 8.88358 10.5846 7.03908C10.5846 5.19457 9.09684 3.70678 7.25234 3.70678ZM7.25234 9.2055C6.06037 9.2055 5.08591 8.23395 5.08591 7.03908C5.08591 5.84421 6.05747 4.87265 7.25234 4.87265C8.4472 4.87265 9.41876 5.84421 9.41876 7.03908C9.41876 8.23395 8.4443 9.2055 7.25234 9.2055ZM11.4982 3.57048C11.4982 4.0026 11.1502 4.34772 10.7209 4.34772C10.2888 4.34772 9.94369 3.9997 9.94369 3.57048C9.94369 3.14125 10.2917 2.79323 10.7209 2.79323C11.1502 2.79323 11.4982 3.14125 11.4982 3.57048ZM13.7052 4.35932C13.6559 3.31816 13.4181 2.39591 12.6553 1.63607C11.8955 0.876222 10.9733 0.638408 9.93209 0.586205C8.85903 0.525301 5.64274 0.525301 4.56968 0.586205C3.53142 0.635508 2.60917 0.873322 1.84642 1.63317C1.08368 2.39301 0.848766 3.31526 0.796563 4.35642C0.735659 5.42948 0.735659 8.64577 0.796563 9.71883C0.845865 10.76 1.08368 11.6822 1.84642 12.4421C2.60917 13.2019 3.52852 13.4397 4.56968 13.4919C5.64274 13.5529 8.85903 13.5529 9.93209 13.4919C10.9733 13.4426 11.8955 13.2048 12.6553 12.4421C13.4152 11.6822 13.653 10.76 13.7052 9.71883C13.7661 8.64577 13.7661 5.43238 13.7052 4.35932ZM12.3189 10.8702C12.0927 11.4386 11.6548 11.8766 11.0835 12.1057C10.2279 12.445 8.19779 12.3667 7.25234 12.3667C6.30688 12.3667 4.27386 12.4421 3.42121 12.1057C2.85278 11.8795 2.41486 11.4415 2.18574 10.8702C1.84642 10.0146 1.92473 7.98453 1.92473 7.03908C1.92473 6.09362 1.84932 4.06061 2.18574 3.20796C2.41196 2.63952 2.84988 2.2016 3.42121 1.97248C4.27676 1.63317 6.30688 1.71147 7.25234 1.71147C8.19779 1.71147 10.2308 1.63607 11.0835 1.97248C11.6519 2.1987 12.0898 2.63662 12.3189 3.20796C12.6582 4.06351 12.5799 6.09362 12.5799 7.03908C12.5799 7.98453 12.6582 10.0175 12.3189 10.8702Z"
      fill="#333333"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.92715 9.13003V14.946H5.09903V9.13003H7.46426L7.95645 6.45581H5.09903V5.50972C5.09903 4.09604 5.65411 3.55464 7.08692 3.55464C7.53262 3.55464 7.89083 3.56558 8.09864 3.58745V1.16206C7.70762 1.05542 6.75059 0.946045 6.19825 0.946045C3.2752 0.946045 1.92715 2.3269 1.92715 5.30464V6.45581H0.122467V9.13003H1.92715Z"
      fill="#333"
    />
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.68613 12.887H0.198219V4.87518H2.68613V12.887ZM1.44084 3.7823C0.645282 3.7823 0 3.12335 0 2.3278C5.69423e-09 1.94567 0.151802 1.57918 0.422011 1.30897C0.69222 1.03876 1.0587 0.886963 1.44084 0.886963C1.82297 0.886963 2.18945 1.03876 2.45966 1.30897C2.72987 1.57918 2.88167 1.94567 2.88167 2.3278C2.88167 3.12335 2.23612 3.7823 1.44084 3.7823ZM11.9976 12.887H9.51503V8.98688C9.51503 8.05739 9.49628 6.8654 8.22152 6.8654C6.92801 6.8654 6.72979 7.87524 6.72979 8.91991V12.887H4.24456V4.87518H6.63068V5.96806H6.66551C6.99766 5.33858 7.80901 4.67428 9.01949 4.67428C11.5374 4.67428 12.0003 6.33235 12.0003 8.48597V12.887H11.9976Z"
      fill="#333333"
    />
  </svg>
);

export const AmazonIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.81356 4.40506C7.24238 4.46313 3.34507 4.90513 3.34507 8.19591C3.34507 11.7286 7.80697 11.8738 9.26523 9.58964C9.47494 9.91872 10.4073 10.7995 10.7267 11.0995L12.5592 9.29283C12.5592 9.29283 11.5172 8.47659 11.5172 7.58937V2.84356C11.5172 2.02732 10.7267 0.188354 7.89408 0.188354C5.05498 0.188354 3.54832 1.96279 3.54832 3.55333L5.91961 3.77272C6.44549 2.17572 7.66824 2.17572 7.66824 2.17572C8.98132 2.1725 8.81356 3.13715 8.81356 4.40506ZM8.81356 7.20545C8.81356 9.78645 6.09706 9.3993 6.09706 7.76036C6.09706 6.23757 7.72631 5.93108 8.81356 5.89559V7.20545ZM13.2013 12.4804C12.9528 12.803 10.9429 14.642 7.57145 14.642C4.20002 14.642 1.61902 12.3352 0.828592 11.3834C0.609207 11.135 0.860855 11.0189 1.00604 11.1157C3.37088 12.5513 7.06493 14.9162 13.0238 12.0932C13.2658 11.9738 13.4529 12.1577 13.2013 12.4804ZM14.4853 12.5513C14.2756 13.0611 13.9691 13.416 13.8013 13.5515C13.6239 13.6967 13.4948 13.6386 13.5916 13.4289C13.6884 13.2192 14.2143 11.9287 14.0014 11.6544C13.7917 11.3867 12.8077 11.5157 12.4528 11.5512C12.1043 11.5835 12.0334 11.6157 12.0011 11.5415C11.9269 11.3576 12.7012 11.0415 13.2109 10.9769C13.7175 10.9189 14.5337 10.9511 14.695 11.1608C14.8144 11.3254 14.695 12.0351 14.4853 12.5513Z"
      fill="#333"
    />
  </svg>
);

export const OrganicIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7311 0.487549L11.9687 0.741694C10.662 1.19569 9.26665 1.33501 7.896 1.14833C6.45573 0.924813 4.98154 1.12343 3.65177 1.72015C2.94682 2.02033 2.32815 2.49207 1.85209 3.09242C1.37602 3.69277 1.05769 4.40267 0.926061 5.15747C0.792169 5.88335 0.805865 6.62875 0.966333 7.34922C1.1268 8.06968 1.43075 8.75044 1.86005 9.35088C1.82192 9.4843 1.7838 9.61773 1.75203 9.75115C1.49397 10.8484 1.36602 11.9723 1.37082 13.0995H2.64154C2.70192 12.1769 2.82719 11.2597 3.01641 10.3548C3.89793 10.8308 4.88651 11.0735 5.88825 11.06C6.82254 11.0594 7.74722 10.8714 8.60761 10.5072C13.4427 8.4423 12.8074 1.57402 12.8074 1.28811L12.7311 0.487549ZM8.11203 9.33817C6.45373 10.0434 4.47139 9.9227 3.3595 9.05225C3.54748 8.42392 3.80535 7.81865 4.12829 7.24782C4.37952 6.83709 4.67573 6.45564 5.01145 6.11052C5.35461 5.76182 5.74111 5.45861 6.16146 5.2083C7.03005 4.68893 7.99334 4.34767 8.99518 4.20443V3.56906C7.84243 3.52842 6.69664 3.76368 5.65317 4.25526C4.58638 4.77651 3.6815 5.57816 3.03547 6.57433C2.79592 6.95489 2.5836 7.35193 2.40011 7.76247C2.10563 7.00915 2.02215 6.18978 2.15867 5.39256C2.24811 4.83441 2.47819 4.30823 2.82723 3.8636C3.17627 3.41896 3.63277 3.07052 4.15371 2.8511C4.91316 2.49543 5.7422 2.31313 6.5808 2.3174C6.97472 2.3174 7.3623 2.35552 7.76893 2.38729C9.0424 2.55159 10.3354 2.47617 11.5811 2.16491C11.5366 3.91851 11.219 8.01661 8.11203 9.33817Z"
      fill="#333333"
    />
  </svg>
);


export const PinterestIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.73143 12.008C4.74659 11.7892 4.77758 11.5723 4.82438 11.3574C4.86533 11.1656 4.98948 10.6229 5.17148 9.83636L5.17603 9.81686L5.42758 8.73266C5.47893 8.51166 5.51858 8.34006 5.54523 8.28286C5.41976 7.99083 5.35687 7.67574 5.36063 7.35791C5.36063 6.48886 5.85203 5.81546 6.48903 5.81546C6.72303 5.81156 6.94663 5.91296 7.10133 6.09236C7.25603 6.27176 7.32753 6.51031 7.29763 6.73976C7.29763 7.03421 7.24238 7.25846 7.00318 8.06251C6.96612 8.18585 6.93036 8.30957 6.89593 8.43366C6.86434 8.54604 6.83552 8.65917 6.80948 8.77296C6.74708 9.02386 6.80428 9.29101 6.96353 9.49121C7.04075 9.58949 7.14046 9.66778 7.25425 9.71948C7.36805 9.77117 7.49261 9.79476 7.61743 9.78826C8.58723 9.78826 9.30743 8.49801 9.30743 6.83206C9.30743 5.55156 8.46893 4.70396 7.07663 4.70396C6.7281 4.69108 6.38069 4.75063 6.05635 4.87885C5.73201 5.00706 5.43779 5.20116 5.19228 5.44886C4.94155 5.70206 4.74374 6.00264 4.61038 6.33308C4.47702 6.66352 4.41078 7.01721 4.41553 7.37351C4.39921 7.75752 4.51685 8.13527 4.74833 8.44211C4.86598 8.53311 4.91083 8.69106 4.86208 8.82561C4.83543 8.93481 4.77108 9.18441 4.74703 9.26761C4.74031 9.30843 4.72419 9.34712 4.69993 9.38063C4.67568 9.41414 4.64396 9.44154 4.60728 9.46066C4.57166 9.47912 4.53217 9.48886 4.49206 9.48909C4.45194 9.48932 4.41235 9.48002 4.37653 9.46196C3.62253 9.15061 3.20913 8.30626 3.20913 7.22596C3.20913 5.28571 4.82828 3.59636 7.23393 3.59636C9.27168 3.59636 10.7966 5.11021 10.7966 6.93736C10.7966 9.23316 9.54078 10.905 7.74808 10.905C7.49303 10.9128 7.23973 10.8604 7.00868 10.7521C6.77764 10.6438 6.57534 10.4826 6.41818 10.2816L6.39023 10.3967L6.25568 10.9505L6.25438 10.9557C6.15948 11.3457 6.09318 11.6167 6.06718 11.7181C5.99784 11.9495 5.91118 12.1748 5.80718 12.3941C7.10055 12.7024 8.46286 12.5034 9.61412 11.8383C10.7654 11.1731 11.6181 10.0922 11.997 8.81778C12.376 7.54333 12.2523 6.17214 11.6515 4.98603C11.0507 3.79992 10.0184 2.88901 8.7667 2.44053C7.51502 1.99205 6.1391 2.04006 4.92174 2.5747C3.70437 3.10933 2.73804 4.08998 2.22137 5.31508C1.70469 6.54018 1.67692 7.91666 2.14377 9.1616C2.61062 10.4065 3.53661 11.4247 4.73143 12.008ZM7.01163 13.8339C3.42168 13.8339 0.511627 10.9238 0.511627 7.33386C0.511627 3.74391 3.42168 0.833862 7.01163 0.833862C10.6016 0.833862 13.5116 3.74391 13.5116 7.33386C13.5116 10.9238 10.6016 13.8339 7.01163 13.8339Z"
      fill="#333333"
    />
  </svg>
);

export const XIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_357_12"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <path
        d="M0.893692 0.793579H13.8937V13.7936H0.893692V0.793579Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_357_12)">
      <path
        d="M11.1312 1.40271H13.1248L8.76983 6.39285L13.8937 13.1844H9.88226L6.73812 9.06621L3.14455 13.1844H1.14905L5.80676 7.84514L0.893692 1.40364H5.00726L7.84498 5.16714L11.1312 1.40271ZM10.4301 11.9884H11.5351L4.40369 2.5365H3.21883L10.4301 11.9884Z"
        fill="#333333"
      />
    </g>
  </svg>
);

export const TvIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.83793 4.29746C1.5656 4.29746 1.34483 4.51823 1.34483 4.79057V11.2009C1.34483 11.4732 1.5656 11.694 1.83793 11.694H11.1621C11.4344 11.694 11.6552 11.4732 11.6552 11.2009V4.79057C11.6552 4.51823 11.4344 4.29746 11.1621 4.29746H1.83793ZM0 4.79057C0 3.77551 0.82287 2.95264 1.83793 2.95264H11.1621C12.1771 2.95264 13 3.77551 13 4.79057V11.2009C13 12.216 12.1771 13.0388 11.1621 13.0388H1.83793C0.82287 13.0388 0 12.216 0 11.2009V4.79057Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.11072 0.236008C3.37331 -0.026586 3.79906 -0.026586 4.06165 0.236008L6.49998 2.67433L8.9383 0.236008C9.2009 -0.026586 9.62665 -0.026586 9.88924 0.236008C10.1518 0.498602 10.1518 0.924351 9.88924 1.18694L6.97545 4.10074C6.71285 4.36333 6.2871 4.36333 6.02451 4.10074L3.11072 1.18694C2.84812 0.924351 2.84812 0.498602 3.11072 0.236008Z"
      fill="#333333"
    />
  </svg>
);

export const DisplayIcon = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08663 7.93696H5.06163V5.33696H4.08663V6.14946H3.11163V7.12446H4.08663V7.93696ZM5.71163 7.12446H10.9116V6.14946H5.71163V7.12446ZM8.96163 5.33696H9.93663V4.52446H10.9116V3.54946H9.93663V2.73696H8.96163V5.33696ZM3.11163 4.52446H8.31163V3.54946H3.11163V4.52446ZM4.41163 11.837V10.537H1.81163C1.45413 10.537 1.14819 10.4098 0.893827 10.1554C0.639461 9.90105 0.512061 9.5949 0.511627 9.23696V1.43696C0.511627 1.07946 0.639027 0.77353 0.893827 0.519163C1.14863 0.264796 1.45456 0.137396 1.81163 0.136963H12.2116C12.5691 0.136963 12.8753 0.264363 13.1301 0.519163C13.3849 0.773963 13.5121 1.0799 13.5116 1.43696V9.23696C13.5116 9.59446 13.3844 9.90061 13.1301 10.1554C12.8757 10.4102 12.5696 10.5374 12.2116 10.537H9.61163V11.837H4.41163ZM1.81163 9.23696H12.2116V1.43696H1.81163V9.23696Z"
      fill="#333333"
    />
  </svg>
);
